import { useState } from "react";

const Support = () => {
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert("Request submitted!");
    setShowForm(false);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginBottom: "20px",
        }}
      >
        <img
          src="/logo512.png"
          width="100"
          height="100"
          alt="Experience Logo"
        ></img>
        <h1>Experience - Info</h1>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <h2>Request access</h2>
        <p>Receive an answer in 1 hour.</p>

        {!showForm ? (
          <button
            onClick={() => setShowForm(true)}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Request Access
          </button>
        ) : (
          <form onSubmit={handleSubmit} style={{ marginTop: "15px" }}>
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="email"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                style={{
                  width: "100%",
                  padding: "8px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  maxWidth: "400px",
                }}
              />
            </div>
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="phone"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Phone number (optional):
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                style={{
                  width: "100%",
                  padding: "8px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  maxWidth: "400px",
                }}
              />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                type="submit"
                style={{
                  padding: "10px 20px",
                  fontSize: "16px",
                  backgroundColor: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                style={{
                  padding: "10px 20px",
                  fontSize: "16px",
                  backgroundColor: "#6c757d",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>

      <div>
        <h2>About the App</h2>
        <p>
          This app was inspired by <strong>flow psychology</strong>, a concept
          developed by
          <strong> Mihaly Csikszentmihalyi</strong>. Flow is the mental state of
          complete absorption in an activity, where you feel fully focused and
          energized.
        </p>
        <p>
          Learn more about flow psychology:
          <a
            href="https://en.wikipedia.org/wiki/Flow_(psychology)"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            Wikipedia - Flow (psychology)
          </a>
        </p>
      </div>

      <img
        src="/screenshot1.png"
        width="414"
        height="896"
        alt="App Screenshot"
      ></img>
    </div>
  );
};

export default Support;
